/* eslint-disable react/display-name */
import { lazy } from "react";
import { Navigate } from "react-router-dom";

const DeviceJobFrequency = lazy(() => import("./pages/device-job-frequency"));

// create user permission component
const DynamicRoleGroupPage = lazy(() => import("./pages/dynamic-role-group"));
const DynamicRoleGroupV2Page = lazy(
  () => import("./pages/dynamic-role-group-v2")
);
const DynamicRoleUserPage = lazy(() => import("./pages/dynamic-role-user"));
const DynamicRoleUserV2Page = lazy(
  () => import("./pages/dynamic-role-user-v2")
);
const DynamicRolePage = lazy(() => import("./pages/dynamic-role"));
// Devices and firmware manage components
const FirmwareManagePage = lazy(() => import("./pages/firmware-manage"));
const DeviceManagePage = lazy(() => import("./pages/devices-manage"));
const IncidentManagePage = lazy(() => import("./pages/incidents-manage"));
const ChecklistPage = lazy(() => import("./pages/repair-checklists"));
const AssetManagePage = lazy(() => import("./pages/asset-manage"));
const TechniciansPage = lazy(() => import("./pages/ktv-manage"));
const ProfileDevicePage = lazy(() => import("./pages/profile-manage/index"));
const StationsManagePage = lazy(() => import("./pages/stations-manage"));
const DeviceQualityReport = lazy(() => import("./pages/quality-report"));
const DeviceDashboard = lazy(() => import("./pages/device-dashboard"));
const ShopManagePage = lazy(() => import("./pages/shop-manage"));
const MachineFaultPage = lazy(() => import("./pages/machine-fault"));
const TechniciansResourcePage = lazy(() => import("./pages/ktv-resource"));
const SupplierRepairLogPage = lazy(() => import("./pages/supplier-repair-log"));
const TransferAssetLogPage = lazy(() => import("./pages/transfer-asset-log"));
const CloseShiftLogPage = lazy(() => import("./pages/close-shift-log"));
const FaultDataManagePage = lazy(() => import("./pages/fault-data-manage"));
const CallCenterLogPage = lazy(() => import("./pages/call-center"));
const SpecDevicePage = lazy(() => import("./pages/spec-device"));
const SpecCommonPage = lazy(() => import("./pages/spec-common"));

const AdminRoutes = [
  { path: "admin/device-job-frequency", element: <DeviceJobFrequency /> },
  { path: "admin/dynamic-role/feature", element: <DynamicRolePage /> },
  { path: "admin/dynamic-role/user", element: <DynamicRoleUserPage /> },
  { path: "admin/dynamic-role/user-v2", element: <DynamicRoleUserV2Page /> },
  { path: "admin/dynamic-role/group-v2", element: <DynamicRoleGroupV2Page /> },
  { path: "admin/dynamic-role/group", element: <DynamicRoleGroupPage /> },
  { path: "admin/dynamic-role/firmware", element: <FirmwareManagePage /> },
  { path: "admin/dynamic-role/device", element: <DeviceManagePage /> },
  { path: "admin/device-incidents", element: <IncidentManagePage /> },
  { path: "admin/repair-checklists", element: <ChecklistPage /> },
  { path: "admin/asset-manage", element: <AssetManagePage /> },
  { path: "admin/ktv-list", element: <TechniciansPage /> },
  { path: "admin/station-manage", element: <StationsManagePage /> },
  { path: "admin/device-quality-report", element: <DeviceQualityReport /> },
  { path: "admin/device-statistics", element: <DeviceDashboard /> },
  { path: "admin/shop-manage", element: <ShopManagePage /> },
  { path: "admin/machine-fault", element: <MachineFaultPage /> },
  { path: "admin/ktv-resource", element: <TechniciansResourcePage /> },
  { path: "admin/supplier-repair-log", element: <SupplierRepairLogPage /> },
  { path: "admin/transfer-asset-log", element: <TransferAssetLogPage /> },
  { path: "admin/close-shift-log", element: <CloseShiftLogPage /> },
  { path: "admin/fault-data-manage", element: <FaultDataManagePage /> },
  { path: "admin/call-center-log", element: <CallCenterLogPage /> },
  {
    path: "admin/spec-device",
    element: <SpecDevicePage />
  },
  {
    path: "admin/spec-common",
    element: <SpecCommonPage />
  }
  // {
  //   path: "admin/dashboard-device",
  //   element: <Navigate to="/device-dashboard" />
  // }
];

export const DeviceRoutes = [
  { path: "profile/:code", element: <ProfileDevicePage /> }
];

export default AdminRoutes;
